import { render, staticRenderFns } from "./Counseling.vue?vue&type=template&id=55e4f4de&"
import script from "./Counseling.vue?vue&type=script&lang=ts&"
export * from "./Counseling.vue?vue&type=script&lang=ts&"
import style0 from "./Counseling.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports